$(document).ready(function(){


  $('.simples-teaser').appendTo('body').addClass('is-loaded');


  function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      vars[key] = value;
    });
		
    return vars;
  }
	
	
	
    var dev = getUrlVars()["dev"];

    if(dev == '1') {
        $('body').append('<style>.simples-teaser { display: none; }');
    } else {
        $('body').append('<style>#smooth-wrapper, .section-header { display: none; } .simples-teaser { z-index: 100000000000; }');
    }



  

  
  $('.mc-embedded-subscribe').click(function(){
    
    var t = $(this).parent('form');
    var inputEmail = t.find('.mce-EMAIL').val();

    function validateEmail($email) {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      return emailReg.test( $email );
    }
    
    if(inputEmail!='') {
      if( !validateEmail(inputEmail)) {
        t.find('.error').addClass('show');
      } else {
        t.find('.error').removeClass('show');
         t.submit();
      }
    
    } else {
      t.find('.error').addClass('show');
    }
    
    return false;
    
  });

  $('.list-legal a').click(function(){
    var x = $(this).attr('href');
    console.log(x);

    $('.overlay-content').hide();

    $(x).show();
    
    $('.overlay').addClass('open');
    $('body').addClass('no-scroll');
    return false;
  });


  $('.close-overlay, .close-bg').click(function(){

    $('.overlay').removeClass('open');
    $('body').removeClass('no-scroll');
    return false;
  });




    AOS.init({
      delay: 200,
      duration: 800,
      offset: 20
    });
  
});